export const enum Direction {
  Rtl = 'rtl',
  Ltr = 'ltr',
}
